import { ID, Insights, InsightSections, Timestamp } from '@griply/types';

import { sortItems } from '../sort-items';

type LifeAreaItem = {
  id: ID;
  archivedAt: Timestamp | null;
};

export type GetInsightsLifeAreasOptions<TLifeArea extends LifeAreaItem> = {
  lifeAreas: TLifeArea[];
  hasLifeScans: boolean;
  insightsSettings: Insights | null | undefined;
  lifeAreaSorting: ID[];
};

export const getInsightsLifeAreas = <TLifeArea extends LifeAreaItem>({
  lifeAreas,
  hasLifeScans,
  insightsSettings,
  lifeAreaSorting,
}: GetInsightsLifeAreasOptions<TLifeArea>): TLifeArea[] => {
  if (!hasLifeScans) {
    return [];
  }

  const lifescanSectionSettings =
    insightsSettings?.sections?.[InsightSections.Lifescan];
  const showHiddenItems = insightsSettings?.showHiddenItems ?? false;

  const filteredLifeAreas = lifeAreas.filter(
    ({ id, archivedAt }) =>
      !archivedAt &&
      (showHiddenItems || !lifescanSectionSettings?.hiddenItems?.includes(id)),
  );

  const sortedLifeAreas = sortItems(filteredLifeAreas, lifeAreaSorting, 'id');

  if (lifescanSectionSettings?.order?.length) {
    return sortItems(sortedLifeAreas, lifescanSectionSettings.order, 'id');
  }

  return sortedLifeAreas;
};
